import React, { useState, useEffect } from 'react'
import { FloatingLabel, Form, Dropdown, Row, Col, ButtonGroup, Button } from 'react-bootstrap'

import Api from 'helpers/Api'
import Loader from 'components/misc/Loader'
import NoDataFound from 'components/misc/NoDataFound'
import { diff, unique } from 'helpers/Arrays'
import { CheckAll, X } from 'react-bootstrap-icons'

function StoreAndDepot(props) {

    const label = props.label || 'Склад';
    const depotInputName = props.depotInputName || '';
    const position = props.position || 'start';

    const [state, setState] = useState({
        data: [],
        show: false,
        selected: [],
        active: null,
        loading: true,
    });

    useEffect(() => {
        let url = props.url || 'autocomplete/depots-by-store';

        Api.get(url, {
            params: {
                permission: props.permission || ''
            }
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: Array.isArray(res.data.items) ? res.data.items : [],
                active: res.data.items[0] ? res.data.items[0].id : null,
                loading: false,
            }));
        });
    }, []);

    useEffect(() => {
        if (Array.isArray(props.selected)) {
            setState(prev => ({
                ...prev,
                selected: props.selected.map(s => Number(s))
            }));
        }
    }, [props.selected]);

    const toggleDropdown = () => {
        setState(prev => ({
            ...prev,
            show: !prev.show,
        }))
    }

    const getFilterValue = () => {
        if (state.selected.length === 0) {
            return 'Няма избрани';
        }

        if (state.selected.length > 3) {
            return state.selected.length + ' избрани';
        }

        let stores = state.data;

        let data = [];

        stores.map(store => {
            let depots = store.depots;

            depots.map(depot => {
                if (isDepotSelected(depot)) {
                    data.push(depot.name);
                }
            });
        });

        return data.join(', ');
    }

    const toggleStore = store => {
        setState(prev => ({
            ...prev,
            active: store.id
        }));
    }

    const isStoreActive = store => {
        return Number(state.active) === Number(store.id);
    }

    const selectStore = store => {
        let selected = [...state.selected];
        let depots = store.depots.map(depot => Number(depot.id));

        if (isStoreSelected(store)) {
            selected = diff(selected, depots);
        } else {
            selected = unique(selected.concat(depots));
        }

        setState(prev => ({
            ...prev,
            selected: selected
        }))

        if (typeof props.onChange === 'function') {
            props.onChange(selected);
        }
    }

    const isStoreSelected = store => {

        let selected = 0;

        store.depots.map(depot => {
            if (isDepotSelected(depot)) {
                selected++;
            }
        });

        if (selected === store.depots.length) {
            return true;
        }

        return false;
    }

    const hasStoreSelectedDepot = store => {

        let selected = 0;

        store.depots.map(depot => {
            if (isDepotSelected(depot)) {
                selected++;
            }
        });

        if (selected > 0) {
            return true;
        }

        return false;
    }

    const selectDepot = depot => {
        let selected = [...state.selected];

        if (isDepotSelected(depot)) {
            selected = selected.filter(id => Number(id) !== Number(depot.id));
        } else {
            selected = selected.concat(depot.id);
        }

        setState(prev => ({
            ...prev,
            selected: selected
        }))

        if (typeof props.onChange === 'function') {
            props.onChange(selected);
        }
    }

    const isDepotSelected = depot => {
        return state.selected.findIndex(id => Number(id) === Number(depot.id)) > -1;
    }

    const selectAll = () => {
        let selected = [];
        let stores = [...state.data];

        stores.map(store => {
            let depots = store.depots.map(depot => Number(depot.id));

            selected = selected.concat(depots);
        });

        setState(prev => ({
            ...prev,
            selected: selected
        }))

        if (typeof props.onChange === 'function') {
            props.onChange(selected);
        }
    }

    const removeAll = () => {
        let selected = [];

        setState(prev => ({
            ...prev,
            selected: selected
        }))

        if (typeof props.onChange === 'function') {
            props.onChange(selected);
        }
    }

    return (
        <Dropdown drop="down" onToggle={toggleDropdown} show={state.show}>
            <FloatingLabel label={label}>
                <Form.Control
                    type="text"
                    placeholder={label}
                    value={getFilterValue()}
                    onClick={toggleDropdown}
                    readOnly
                    style={{ cursor: 'pointer' }}
                />
            </FloatingLabel>
            <Dropdown.Menu align="start" className={position} style={{ padding: '15px', width: '280px' }}>
                {state.loading
                    ?
                    <Loader />
                    :
                    state.data.length === 0
                        ?
                        <NoDataFound size="sm">
                            Няма складове за показване!
                        </NoDataFound>
                        :
                        <>
                            <div className="depots-filter">
                                {/* <div className="header">
                                    <div>
                                        Магазин
                                    </div>
                                    <div>
                                        Складове
                                    </div>
                                </div> */}
                                <div className="body">
                                    <div className="stores">
                                        {state.data.map((store, i) =>
                                            <React.Fragment key={store.id}>
                                                <div className={`store ${isStoreActive(store) ? 'active' : ''}`} onClick={e => toggleStore(store)}>
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={e => selectStore(store)}
                                                            checked={isStoreSelected(store)}
                                                        />
                                                        <span className={`${hasStoreSelectedDepot(store) ? 'has-selected-depot' : ''} ${store.deleted_at ? 'deleted' : ''}`} onClick={e => e.preventDefault()}>
                                                            {store?.translation?.name || store?.name}
                                                        </span>
                                                    </label>
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>

                                    {state.data.map((store, i) =>
                                        <div key={'depots-' + i} className={`depots  ${isStoreActive(store) ? 'active' : ''}`}>
                                            {store.depots.map(depot =>
                                                <div key={depot.id} className="depot">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={e => selectDepot(depot)}
                                                            checked={isDepotSelected(depot)}
                                                            name={depotInputName}
                                                            value={depot.id}
                                                        />
                                                        <span>{depot?.translation?.name || depot?.name}</span>
                                                    </label>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="all-options">
                                    <ButtonGroup style={{ width: '100%' }}>
                                        <Button variant="primary" size="sm" onClick={selectAll}>
                                            <CheckAll /> Всички
                                        </Button>
                                        <Button variant="secondary" size="sm" onClick={removeAll}>
                                            <X /> Изчисти
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </>
                }
            </Dropdown.Menu>
        </Dropdown >
    )
}

export default StoreAndDepot;